import { Box, Button, CssBaseline, CssVarsProvider, Link } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../VendorSidebar";
import { SelectInput, TextInput } from "../../utils/input";
import { useGetTDSAllAttachmentsMutation, useGetVendorDownloadTdsMutation, useGetVendorListWithSearchQuery } from "../../services/vendor/VendorApi";
import { toast } from "react-toastify";
import EmployeeSidebar from "../EmployeeSidebar";
import SearchIcon from "@mui/icons-material/Search";
import { CardContent, Typography } from "@mui/material";
import { useGetVerifyVendorMutation } from "../../services/auth/authApiSlice";




const ListView = ({ vendorList, haneledClickItem, ref }) => {
    return (
        <Box className="vendor-search-list" ref={ref}>
            <nav aria-label="secondary mailbox folders">
                {vendorList.map((item, index) => {
                    return (
                        <div key={"sfd" + item.vendor_code + item.username} onClick={() => haneledClickItem(item.vendor_code)} className="ventor-item">
                            {item.vendor_code + " " + item.username}
                        </div>
                    );
                })}
            </nav>
        </Box>
    );
};
export default function TdsFileDownloadEmployee() {

    const [formData, setFormData] = useState<any>({
        attachment: null,
        attachmentPreview: null,
        existingAttachmentName: "",
        name: "",
    });

    const [vendorList, setVendorList] = useState([]);
    const [vendorDetails, setVendorDetails] = useState(null);
    const [vendorNameId, setVendorNameId] = useState("");
    const [quarterList, setquarterList] = useState([]);
    const [fiscalYear, setFiscalYear] = useState("");
    const [getAllVendor, setGetAllVendor] = useState([]);
    const [page, setPage] = React.useState(1);
    const [pagination, setPagination] = React.useState(null);

    const { data: allVendorList } = useGetVendorListWithSearchQuery(0);
    // const [getDownloadFle] = useGetVendorDownloadTdsMutation();
    const [getDownloadFle] = useGetTDSAllAttachmentsMutation();
    const [getVerifyVendor] = useGetVerifyVendorMutation();
    const ref: any = useRef(0);

    var dat = new Date();
    var y = dat.getMonth();
    var cYear = new Date().getFullYear() + 1;
    const years: any = Array.from({ length: cYear - 1980 }, (_, i) => 1980 + i);
    const yearOption = years.reverse().map((item) => {
        var obj: any = {};
        var yr = String(item).replace(/^.{2}/, "");
        obj.value = y > 2 ? (item + "-" + (+yr + 1)) : ((item - 1) + "-" + yr);
        obj.label = y > 2 ? (item + "-" + (item + 1)) : ((item - 1) + "-" + item);
        return obj;
    });


    useEffect(() => {
        if (allVendorList) {
            setGetAllVendor([...allVendorList]);
        }
    }, [allVendorList])

    const handleSelectChange = (name: string, value: string) => {

        console.log(value)
        setFiscalYear(value);
        setquarterList([]);
    };
    const handleDownloadFile = async (page1: any) => {
        setPage(page1);
        try {

            var payload: any = "page=" + page1 + "&per_page=100&vendor_code=" + (vendorDetails ? vendorDetails?.lifnr : '') + "&fiscal_year=" + fiscalYear
            var { data } = await getDownloadFle(payload);
            if (data) {
                setquarterList([...data.data]);
                setPagination({ ...data.pagination });
            }

        } catch (err) {
            let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
            toast.error(errorMessage);
        }
    };

    const handleFileDownload = (link) => {
        window.open(link, "_blank");

        // Clean up the URL after a short delay to allow the browser to load it
        setTimeout(() => {
            URL.revokeObjectURL(link);
        }, 1000);
    };


    const haneledClickItem = async (vendor_id) => {
        try {
            setVendorList([]);
            const response = await getVerifyVendor(vendor_id).unwrap();
            setVendorDetails(response?.message);
            setFiscalYear('');
            setquarterList([]);
        } catch (err) {
            console.error(err);
            let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
            toast.error(errorMessage);
        }
    };
    const handleInputChange = (event: any) => {
        setVendorNameId(event.target.value);
    };

    const handleSearchVendor = async () => {
        const response: any = getAllVendor?.filter((item: any, index: any) => item?.vendor_code.includes(vendorNameId) || item?.username.includes(vendorNameId));
        if (response) {
            console.log(response)
            setVendorList([...response]);
        }
    };


    return (
        <CssVarsProvider disableTransitionOnChange>
            <CssBaseline />
            <Box sx={{ display: "flex", minHeight: "92dvh", background: "white" }}>
                {localStorage.getItem("userRole") === "employee" ? <EmployeeSidebar /> : <Sidebar />}
                <div className="form-center">
                    <div className="add-entry-outer register-box" style={{ padding: "20px" }}>

                        <div className="search-vendor">
                            <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "130px" }} style={{ width: "620px", paddingLeft: 0, paddingRight: 0 }}>
                                <TextInput name="vendoridorName" label="Search vendor id or Name" value={vendorNameId} onChange={handleInputChange} placeholder={"Enter vendor id or Name"} />
                            </Box>
                            <Button className="search-icon" disabled={vendorNameId.length === 0} onClick={handleSearchVendor}>
                                <SearchIcon />
                            </Button>
                            {vendorList.length > 0 && <ListView vendorList={vendorList} haneledClickItem={haneledClickItem} ref={ref} />}
                        </div>
                        {vendorDetails && <CardBox vendorDetails={vendorDetails} />}

                        <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "130px" }} style={{ width: "700px" }}>
                            <SelectInput name="fiscalyear" label="Fiscal Year" value={fiscalYear} onChange={handleSelectChange} options={yearOption} />
                        </Box>
                        {quarterList.length > 0 && (
                            <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "30px" }} className="file-upload-tds" style={{ width: "700px" }}>
                                <table className="quarter-table" cellPadding={10}>
                                    <thead>
                                        <tr>
                                            <th>Quarter</th>
                                            <th>Vendor Code</th>
                                            {/* <th>Vendor Name</th> */}
                                            <th>Fiscal Year</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quarterList?.map((item, index) => {
                                            return (
                                                <tr key={"sdhfkdsjf" + index}>
                                                    <td align="center">{item.quarter}</td>
                                                    <td align="center">{item.vendor_code}</td>
                                                    {/* <td align="center">{item.vendor_name}</td> */}
                                                    <td align="center">{item.fiscal_year}</td>
                                                    <td align="center">
                                                        <Link onClick={() => handleFileDownload(item.doc_url)} level="body-sm" sx={{ cursor: "pointer", mx: "auto" }}>
                                                            View/Download
                                                        </Link>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </Box>
                        )}

                        {quarterList.length !== 0 && <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                            }}
                        >
                            <Box sx={{ display: "flex", gap: 1, paddingLeft: 3 }}>
                                <Button size="sm" variant="outlined" onClick={() => handleDownloadFile(page - 1)} disabled={pagination === null || pagination?.page === 1}>
                                    Previous
                                </Button>
                                <Button size="sm" variant="outlined" onClick={() => handleDownloadFile(page + 1)} disabled={pagination === null || pagination?.pages === page}>
                                    Next
                                </Button>
                            </Box>
                        </Box>}

                        {quarterList.length == 0 && (
                            <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2.5, pb: "130px" }} className="file-upload-tds" style={{ width: "700px" }}>
                                <Button disabled={fiscalYear === "" && !vendorDetails} onClick={() => handleDownloadFile(page)}>
                                    Submit
                                </Button>
                            </Box>
                        )}
                    </div>
                </div>
            </Box>
        </CssVarsProvider>
    );
}




const CardBox = ({ vendorDetails }) => {
    return (
        <Box className="vendor-card" style={{ width: "700px", paddingLeft: 0, paddingRight: 0 }}>
            <CardContent style={{ padding: "0px" }}>
                <Typography component="div" style={{ lineHeight: "30px", paddingLeft: "20px" }}>
                    <b>Vendor Code :</b> {vendorDetails.lifnr}
                </Typography>
                <Typography component="div" style={{ lineHeight: "30px", paddingLeft: "20px" }}>
                    <b>Vendor Name :</b> {vendorDetails.name}
                </Typography>
                <Typography component="div" style={{ lineHeight: "30px", paddingLeft: "20px" }}>
                    <b>Phone No. :</b> {vendorDetails.contactNumber}
                </Typography>
                <Typography component="div" style={{ lineHeight: "30px", paddingLeft: "20px" }}>
                    <b>Address :</b> {vendorDetails.emailId}
                </Typography>
            </CardContent>
        </Box>
    );
};